import { PAGE_ARE_LOADING, PAGE_FETCH_DATA_SUCCESS, PAGE_HAVE_ERROR } from '../actionType';
// import { CONTACTUS_ARE_LOADING, CONTACTUS_FETCH_DATA_SUCCESS, CONTACTUS_HAVE_ERROR } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function PageReducer(state = initialState, action) {
    switch (action.type) {
        case PAGE_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case PAGE_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case PAGE_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.Page,
                loading:false,
            }

        default:
            return state;
    }
}
